<ng-template #resourceTemplateLowLevel let-arg="arg" let-flowDetail="flowDetail">
  @if (arg.rsc.type === 'unknown_ip' || arg.rsc.type === 'internet_ip') {
  {{arg.rsc.name}}
  <!-- Beware, flow.direction is 1 if the port is on the source. This is why we do 'flowDetail.direction != arg.dir' -->
  @if (showPortInline && flowDetail.direction != arg.dir) {
    <span class="">:{{flowDetail.port}}</span>
  }
  <clr-signpost>
    <button class="btn btn-link btn-icon" aria-label="Icon Button Trigger" style="height: 16px;" clrSignpostTrigger>
      <cds-icon (click)="resolveDomain(flowDetail, arg.dir)" shape="network-settings" class="is-solid has-badge-info"></cds-icon>
    </button>
    <clr-signpost-content *clrIfOpen>
      <table class="table">
        <thead>
          <tr>
            <th>key</th>
            <th>value</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>url</td>
            <td>
              @if(arg.rsc.resolvedDomain?.result == undefined || arg.rsc.resolvedDomain?.result == '') {
                <span class="label label-warning">not resolved</span>
              } @else {
                <span class="label label-primary">{{ arg.rsc.resolvedDomain?.result }}</span>
              }
            </td>
          </tr>
          <tr>
            <td>geography</td>
            <td>{{ arg.rsc.resolvedDomain?.geoip?.country }}</td>
          </tr>
           @for(asn of arg.rsc.resolvedDomain?.geoip?.asns; track asn.asn_number) {
            <tr>
              <td>asn {{ $count }}</td>
              <td>{{ asn?.asn_description }}</td>
            </tr>
           }
        </tbody>
      </table>
    </clr-signpost-content>
  </clr-signpost>

} @else {
  <clr-tooltip>
    @if (arg.rsc.type === 'external_ip') {
      @if (showPortInline && flowDetail.direction != arg.dir) {
        <span clrTooltipTrigger style="margin-right: 0px;" class="badge badge-orange" (click)="switchFocus(arg.rsc)">
          {{arg.rsc.name}}
          <span class="">:{{flowDetail.port}}</span>
        </span>
      } @else {
        <span clrTooltipTrigger style="margin-right: 0px;" class="badge badge-orange" (click)="switchFocus(arg.rsc)">{{arg.rsc.name}}</span>
      }
    } @else if (arg.rsc.type === 'vm') {
      @if (showPortInline && flowDetail.direction != arg.dir) {
        <span clrTooltipTrigger style="margin-right: 0px;" class="badge badge-blue" (click)="switchFocus(arg.rsc)">
          {{arg.rsc.name}}
          <span class="">:{{flowDetail.port}}</span>
        </span>
      } @else {
        <span clrTooltipTrigger style="margin-right: 0px;" class="badge badge-blue" (click)="switchFocus(arg.rsc)">{{arg.rsc.name}}</span>
      }
    } @else if (arg.rsc.type === 'host') {
      @if (showPortInline && flowDetail.direction != arg.dir) {
        <span clrTooltipTrigger style="margin-right: 0px;" class="badge" (click)="switchFocus(arg.rsc)">
          {{arg.rsc.name}}
          <span class="">:{{flowDetail.port}}</span>
        </span>
      } @else {
        <span clrTooltipTrigger style="margin-right: 0px;" class="badge" (click)="switchFocus(arg.rsc)">{{arg.rsc.name}}</span>
      }
    } @else if (arg.rsc.type === 'asn') {
      @if (showPortInline && flowDetail.direction != arg.dir) {
        <span clrTooltipTrigger style="margin-right: 0px;" class="badge" (click)="switchFocus(arg.rsc)">
          {{arg.rsc.name}}
          <span class="">:{{flowDetail.port}}</span>
        </span>
      } @else {
        <span clrTooltipTrigger style="margin-right: 0px;" class="badge" (click)="switchFocus(arg.rsc)">{{arg.rsc.name}}</span>
      }
    }
    <clr-tooltip-content [clrPosition]="'top-right'" [clrSize]="'sm'">
     {{ arg.rsc.address }}
    </clr-tooltip-content>
  </clr-tooltip>
}
</ng-template>

<clr-datagrid (clrDgRefresh)="refresh($event)" [clrDgLoading]="flowsRepository?.isLoading">
    @if (!mergeSourceAndTarget) {
      <clr-dg-column [clrDgField]="'src_ipaddr'">
          Source
          <clr-dg-filter [clrDgFilter]="sourceResourceFilter">
              <resource-filter
                [items]="flowDetails"
                [flowsRepository]="flowsRepository"
                [sharedOptions]="sharedOptions"
                [side]="'source'"
                [tableUpdate]="shouldUpdateFilters" [label]="'Displayable storage types'"
                #sourceResourceFilter
              >
              </resource-filter>
          </clr-dg-filter>
      </clr-dg-column>
      <clr-dg-column *ngIf="showHosts">
          Source Host
      </clr-dg-column>
      <clr-dg-column [clrDgField]="'dst_ipaddr'">
          Destination
          <clr-dg-filter [clrDgFilter]="destinationResourceFilter">
              <resource-filter
                [items]="flowDetails"
                [flowsRepository]="flowsRepository"
                [sharedOptions]="sharedOptions"
                [side]="'destination'"
                [tableUpdate]="shouldUpdateFilters" [label]="'Displayable storage types'"
                #destinationResourceFilter
              >
              </resource-filter>
          </clr-dg-filter>
      </clr-dg-column>
      <clr-dg-column *ngIf="showHosts">
          Destination Host
      </clr-dg-column>
    } @else {
      <clr-dg-column [clrDgField]="'src_ipaddr'">
          Link
      </clr-dg-column>
    }

    <ng-container *ngIf="showCountry">
        <clr-dg-column [clrDgField]="'src_country_code'">
            Source Country
            <clr-dg-filter [clrDgFilter]="sourceCountryFilter">
                <discrete-values-filter
                  [items]="flowDetails"
                  [column]="'src_country_code'"
                  [flowsRepository]="flowsRepository"
                  [selectorToObject]="sourceCountrySelector"
                  [tableUpdate]="shouldUpdateFilters" #sourceCountryFilter>
                </discrete-values-filter>
            </clr-dg-filter>
        </clr-dg-column>
        <clr-dg-column [clrDgField]="'dst_country_code'">
            Destination Country
            <clr-dg-filter [clrDgFilter]="targetCountryFilter">
                <discrete-values-filter
                  [items]="flowDetails"
                  [column]="'dst_country_code'"
                  [flowsRepository]="flowsRepository"
                  [selectorToObject]="targetCountrySelector"
                  [tableUpdate]="shouldUpdateFilters" #targetCountryFilter>
                </discrete-values-filter>
            </clr-dg-filter>
        </clr-dg-column>
    </ng-container>

    <ng-container *ngIf="showASN">
        <clr-dg-column [clrDgField]="'src_asn_num'">
            Source Network
            <clr-dg-filter [clrDgFilter]="sourceNetworkFilter">
                <discrete-values-filter
                  [items]="flowDetails"
                  [column]="'src_asn_num'"
                  [flowsRepository]="flowsRepository"
                  [selectorToObject]="sourceNetworkSelector"
                  [tableUpdate]="shouldUpdateFilters" #sourceNetworkFilter>
                </discrete-values-filter>
            </clr-dg-filter>
        </clr-dg-column>
        <clr-dg-column [clrDgField]="'dst_asn_num'">
            Destination Network
            <clr-dg-filter [clrDgFilter]="targetNetworkFilter">
                <discrete-values-filter
                  [items]="flowDetails"
                  [column]="'dst_asn_num'"
                  [flowsRepository]="flowsRepository"
                  [selectorToObject]="targetNetworkSelector"
                  [tableUpdate]="shouldUpdateFilters" #targetNetworkFilter>
                </discrete-values-filter>
            </clr-dg-filter>
        </clr-dg-column>
    </ng-container>

    <ng-container *ngIf="showThreats">
        <clr-dg-column [clrDgField]="'date'" [clrDgSortOrder]="showThreats ? descSort : unsortedSort">
            Date
        </clr-dg-column>
        <clr-dg-column [clrDgField]="'score'">
            Risk Score
        </clr-dg-column>
        <clr-dg-column [clrDgField]="'reason'">
            Reason
        </clr-dg-column>
        <clr-dg-column [clrDgField]="'reason'">
            Origin
            <clr-dg-filter [clrDgFilter]="threatOriginFilter">
                <discrete-values-filter
                  [items]="flowDetails"
                  [selectorToObject]="threatOriginSelector"
                  [tableUpdate]="shouldUpdateFilters" #threatOriginFilter>
                </discrete-values-filter>
            </clr-dg-filter>
        </clr-dg-column>
        <clr-dg-column [clrDgField]="'categories'">
           Categories
            <clr-dg-filter [clrDgFilter]="categoriesFilter">
                <threats-tags-filter
                  [items]="flowDetails"
                  [selectorToList]="categoriesSelector"
                  [tableUpdate]="shouldUpdateFilters" #categoriesFilter>
                </threats-tags-filter>
            </clr-dg-filter>
        </clr-dg-column>
        <clr-dg-column [clrDgField]="'tags'">
            Tags
            <clr-dg-filter [clrDgFilter]="tagsFilter">
                <discrete-values-filter
                  [items]="flowDetails"
                  [selectorToList]="tagsSelector"
                  [tableUpdate]="shouldUpdateFilters" #tagsFilter>
                </discrete-values-filter>
            </clr-dg-filter>
        </clr-dg-column>
    </ng-container>

    <ng-container *ngIf="perPortRow">
        <clr-dg-column [clrDgField]="'port'" [clrDgSortOrder]="descSort">Port</clr-dg-column>
        <clr-dg-column [clrDgField]="'protocol'">Protocol</clr-dg-column>
    </ng-container>

    <clr-dg-column [clrDgField]="'exchanged_bytes'" [clrDgSortOrder]="showThreats ? unsortedSort : descSort" *ngIf="!hideTotalBytes">
        Total bytes
        <clr-dg-filter [clrDgFilter]="totalBytesFilter">
            <column-range-filter [fieldName]="'exchanged_bytes'" [items]="flowDetails"
                                 [flowsRepository]="flowsRepository"
                                 [formatType]="'bytes'"
                                 [tableUpdate]="shouldUpdateFilters" #totalBytesFilter>
            </column-range-filter>
        </clr-dg-filter>
    </clr-dg-column>
    <clr-dg-column [clrDgField]="'exchanged_packets'" *ngIf="!hidePacketsExchanged">
        Total (packets)
        <clr-dg-filter [clrDgFilter]="totalPacketsFilter">
            <column-range-filter [fieldName]="'exchanged_packets'" [items]="flowDetails"
                                 [flowsRepository]="flowsRepository"
                                 [formatType]="'numbers'"
                                 [tableUpdate]="shouldUpdateFilters" #totalPacketsFilter>
            </column-range-filter>
        </clr-dg-filter>
    </clr-dg-column>
    <clr-dg-column *ngIf="showActions">Actions</clr-dg-column>

    <clr-dg-row *ngFor="let flowDetail of flowDetails" [clrDgItem]="flowDetail">
      @if (!mergeSourceAndTarget) {
        <ng-container *ngFor="let arg of [{addr: flowDetail.src_ipaddr, resolved: flowDetail.src_ip_resolved, resolved_class: flowDetail.src_ip_resolved_class, rsc: flowDetail.source, dir: 0}, {addr: flowDetail.dst_ipaddr, resolved: flowDetail.dst_ip_resolved, resolved_class: flowDetail.dst_ip_resolved_class, rsc: flowDetail.target, dir: 1}]">
            <!-- The following container is for resources that are clickable and associated to an action -->
            <ng-container>
              <clr-dg-cell>
                <ng-container *ngTemplateOutlet="resourceTemplateLowLevel; context: { arg: arg, flowDetail: flowDetail }"></ng-container>
              </clr-dg-cell>
            </ng-container>
            <!-- The following container is for when host of resource should be displayed -->
            <ng-container *ngIf="showHosts">
              @if (arg.rsc !== undefined && arg.rsc.type === 'vm') {
                @if (arg.rsc.host !== undefined) {
                  <clr-dg-cell><span class="badge">{{arg.rsc.host.name}}</span></clr-dg-cell>
                } @else {
                  <clr-dg-cell><span class="badge danger">unknown</span></clr-dg-cell>
                }
              } @else {
                <clr-dg-cell>n/a</clr-dg-cell>
              }
            </ng-container>
        </ng-container>
      }
      @else {
        <clr-dg-cell>
          <ng-container *ngTemplateOutlet="resourceTemplateLowLevel; context: { arg: {addr: flowDetail.src_ipaddr, resolved: flowDetail.src_ip_resolved, resolved_class: flowDetail.src_ip_resolved_class, rsc: flowDetail.source, dir: 0}, flowDetail: flowDetail }"></ng-container>
          &rarr;
          <ng-container *ngTemplateOutlet="resourceTemplateLowLevel; context: { arg: {addr: flowDetail.dst_ipaddr, resolved: flowDetail.dst_ip_resolved, resolved_class: flowDetail.dst_ip_resolved_class, rsc: flowDetail.target, dir: 1}, flowDetail: flowDetail }"></ng-container>
        </clr-dg-cell>
      }

        <ng-container *ngIf="perPortRow">
            <clr-dg-cell>
              @if (flowDetail.port === -1) {
                <span class="label">all ports</span>
              } @else {
                <span class="label">{{flowDetail.port}}</span>
              }
              <span class="label label-info" *ngFor="let transport_protocol of flowDetail.transport_protocols">{{transport_protocol}}</span>
            </clr-dg-cell>
            <clr-dg-cell>
                <a style="margin-right: 5px;" routerLink="/flows/protocol-analysis/protocols/{{flowDetail.protocol}}" [queryParams]="{}" routerLinkActive="active">
                    <span class="label">{{flowDetail.protocol}}</span>
                </a>
            </clr-dg-cell>
        </ng-container>

      @if(showCountry) {
        <ng-container>
            <clr-dg-cell>
              @if (flowDetail.source.countryInfo?.country == undefined) {
                <span class="label">this infrastructure</span>
              } @else {
                {{ flowDetail.source.countryInfo?.country }}
              }
            </clr-dg-cell>
            <clr-dg-cell>
              @if (flowDetail.target.countryInfo?.country == undefined) {
                <span class="label">this infrastructure</span>
              } @else {
                {{ flowDetail.target.countryInfo?.country }}
              }
            </clr-dg-cell>
        </ng-container>
      }

      @if(showASN) {
        <ng-container>
            <clr-dg-cell>
              @if (flowDetail.source.asnInfo?.asn == undefined) {
                <span class="label">this infrastructure</span>
              } @else {
                {{ flowDetail.source.asnInfo?.asn }}
              }
            </clr-dg-cell>
            <clr-dg-cell>
              @if (flowDetail.target.asnInfo?.asn == undefined) {
                <span class="label">this infrastructure</span>
              } @else {
                {{ flowDetail.target.asnInfo?.asn }}
              }
            </clr-dg-cell>
        </ng-container>
      }

        <ng-container *ngIf="showThreats">
            <clr-dg-cell>{{ flowDetail.date * 1000 | date: 'dd/MM/yyyy HH:mm'}}</clr-dg-cell>
            <clr-dg-cell>

                <span class="label">
                    <span class="text">{{ flowDetail.threat.score * 100 }} %</span>

                    <span class="badge badge-info" *ngIf="flowDetail.threat.risk_level == 'low'">low</span>
                    <span class="badge badge-warning" *ngIf="flowDetail.threat.risk_level == 'medium'">medium</span>
                    <span class="badge badge-danger" *ngIf="flowDetail.threat.risk_level == 'high'">high</span>
                </span>

            </clr-dg-cell>
            <clr-dg-cell>
                {{ flowDetail.threat.ip }} hosts threats
            </clr-dg-cell>
            <clr-dg-cell>
                {{ flowDetail.threat.origin }}
            </clr-dg-cell>
            <clr-dg-cell>
              @for(category of flowDetail.threat.categories; track category) {
                <label class="label label label-danger">{{ category }}</label>
              }
            </clr-dg-cell>
            <clr-dg-cell>
                <label class="label label label-warning" *ngFor="let tag of flowDetail.threat.tags">{{ tag }}</label>
            </clr-dg-cell>
        </ng-container>

        <clr-dg-cell *ngIf="!hideTotalBytes">{{ NetscopeUtils.formatBytes(flowDetail.exchanged_bytes) }}</clr-dg-cell>
        <clr-dg-cell *ngIf="!hidePacketsExchanged">{{flowDetail.exchanged_packets | number}}</clr-dg-cell>

        <ng-template #actions_if_true>
            <a *ngIf="flowDetail.showDependencyViewerIcon" style="margin-right: 5px;" routerLink="/flows/dependencies-viewer" [queryParams]="flowDetail.threat === undefined ? {origin: 'fromDatagrid', start_time: temporalParameter.startTime, end_time: temporalParameter.endTime, time_resolution: temporalParameter.timeResolution, focusedResources: [flowDetail.source.uuid, flowDetail.target.uuid], show_everything: 'yes'} : {origin: 'fromDatagrid', start_time: flowDetail.date, end_time: flowDetail.date, time_resolution: 'hourly', focusedResources: [flowDetail.source.uuid, flowDetail.target.uuid], show_everything: 'yes'}" routerLinkActive="active"><cds-icon shape="recycle"></cds-icon></a>
            <a *ngIf="flowDetail.showClustersViewerIcon" style="margin-right: 5px;" routerLink="/flows/clusters-viewer" [queryParams]="flowDetail.threat === undefined ? {origin: 'fromDatagrid', start_time: temporalParameter.startTime, end_time: temporalParameter.endTime, time_resolution: temporalParameter.timeResolution, focusedResources: [flowDetail.source.uuid, flowDetail.target.uuid], show_everything: 'yes'} : {origin: 'fromDatagrid', start_time: flowDetail.date, end_time: flowDetail.date, time_resolution: 'hourly', focusedResources: [flowDetail.source.uuid, flowDetail.target.uuid], show_everything: 'yes'}" routerLinkActive="active"><cds-icon shape="organization"></cds-icon></a>
            <a *ngIf="flowDetail.showHeatmapViewerIcon" routerLink="/heatmap-viewer/{{flowDetail.source.uuid}}_{{flowDetail.source.address}}/{{flowDetail.target.uuid}}_{{flowDetail.target.address}}" [queryParams]="flowDetail.threat === undefined ? {origin: 'fromDatagrid', start_time: temporalParameter.startTime, end_time: temporalParameter.endTime, time_resolution: temporalParameter.timeResolution} : {origin: 'fromDatagrid', start_time: flowDetail.date, end_time: flowDetail.date, time_resolution: 'hourly'}" routerLinkActive="active"><cds-icon shape="heat-map"></cds-icon></a>

            <ng-container *ngIf="showThreats">
                <a target="_blank" href="{{ flowDetail.threat.link }}"><span class="label label-info"> <cds-icon shape="info-circle"></cds-icon> more info</span></a>
            </ng-container>
        </ng-template>
        <ng-template #actions_if_not_true></ng-template>
        <clr-dg-cell *ngIf="showActions">
            <div *ngIf="flowDetail.showActions; then actions_if_true else actions_if_not_true"></div>
        </clr-dg-cell>

        <ng-container ngProjectAs="clr-dg-row-detail" *ngIf="!perPortRow && expandable">
            <app-expandable-rows
              *clrIfExpanded
              [flowDetail]="flowDetail"
              [flowsRepository]="flowsRepository"
              [bidirectional]="bidirectional"
              [temporalParameter]="flowDetail.threat === undefined ? temporalParameter : flowDetail.temporalParameter"
              ngProjectAs="clr-dg-row-detail">
            </app-expandable-rows>
        </ng-container>
    </clr-dg-row>

    <clr-dg-footer>
        <clr-dg-pagination #pagination [clrDgPageSize]="20" [clrDgTotalItems]="totalItemsCount">
            <clr-dg-page-size [clrPageSizeOptions]="[10,20,50,100]">Flows per page</clr-dg-page-size>
            {{pagination.firstItem + 1}} - {{pagination.lastItem + 1}} of {{pagination.totalItems}} flows
        </clr-dg-pagination>

        <clr-dropdown style="float: left" *ngIf="exportCsvEnabled">
          <button id="export_csv_button" class="btn btn-sm" style="float: left;" clrDropdownTrigger>
            Export CSV
          </button>
          <clr-dropdown-menu clrPosition="top-left" *clrIfOpen>
            <label class="dropdown-header" aria-hidden="true">Export flows as</label>
            <div aria-label="Dropdown header Action 1" clrDropdownItem (click)="callExportCsv()">CSV file</div>
            <div aria-label="Dropdown header Action 2" clrDropdownItem (click)="callExportCsvWithPortsDetails()">CSV file (ports details)</div>
          </clr-dropdown-menu>
      </clr-dropdown>
    </clr-dg-footer>

</clr-datagrid>
